import React from 'react';
import dynamic from 'next/dynamic';
import { Loader } from '@/components';
import { MetaData } from '@/containers';
import { fetchNews, getNewsData } from '@fh-components/fh-js-api-core/store/slices/pagesSlice';
import qs from 'qs';
import redirectFirstPage from '@/lib/redirectFirstPage';
import { handleError } from '@/lib/handleError';
import ecommerce from '@/seo/Ecommerce';

const NewsPage = dynamic(() => import('../../layouts/NewsPage'), {
	loading: () => <Loader />,
});

const NextNewsPage = props => {
	ecommerce.setPageType(ecommerce.PAGE_TYPES.NEWS);

	return (
		<>
			<MetaData
				title='Новости | FH.BY'
				description='Актуальные новости и авторские статьи от FH.BY'
				seo={props?.seo}
				withPage
			/>

			<NewsPage {...props} />
		</>
	);
};

NextNewsPage.getInitialProps = async ({ reduxStore, query, res, asPath }) => {
	const { page } = qs.parse(query);

	redirectFirstPage({ page, res, asPath });

	await reduxStore.dispatch(fetchNews({ page: page || 1, per_page: 12 }));

	const pageData = getNewsData(reduxStore.getState());

	handleError(pageData.error);

	return pageData?.data ?? {};
};

export default NextNewsPage;
